import { Sidebar, SidebarContent } from "@elit-hair/elit-ui";

import { DarwinAI } from "@/components/ai-chat";

export function SidebarRight() {
    return (
        <Sidebar side="right" variant="inset" collapsible="offcanvas">
            <SidebarContent className="h-full overflow-hidden p-2 pr-2">
                <DarwinAI />
            </SidebarContent>
        </Sidebar>
    );
}
